import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { AuthGuard } from '@common/access-guard/auth-guard.class';

const routes: Routes = [
    {
        path: '',
        component: AppComponent,
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('./modules/sign-in/sign-in.module').then(
                        (m) => m.SignInModule
                    ),
            },
            {
                path: 'catalog',
                canActivate: [AuthGuard],
                loadChildren: () =>
                    import('./modules/catalog/catalog.module').then(
                        (m) => m.CatalogModule
                    ),
            },
            {
                path: 'participant',
                canActivate: [AuthGuard],
                loadChildren: () =>
                    import('./modules/participant/participant.module').then(
                        (m) => m.ParticipantModule
                    ),
            },
            {
                path: 'administrator',
                canActivate: [AuthGuard],
                loadChildren: () =>
                    import(
                        './modules/administrator/application/administrator.module'
                    ).then((m) => m.AdministratorModule),
            },
            {
                path: 'commercial-manager',
                canActivate: [AuthGuard],
                loadChildren: () =>
                    import(
                        './modules/commercial-manager/commercial-manager.module'
                    ).then((m) => m.CommercialManagerModule),
            },
            {
                path: 'credit-specialist',
                canActivate: [AuthGuard],
                loadChildren: () =>
                    import(
                        './modules/credit-specialist/credit-specialist.module'
                    ).then((m) => m.CreditSpecialistModule),
            },
            {
                path: 'terms-and-conditions',
                canActivate: [AuthGuard],
                loadChildren: () =>
                    import(
                        './modules/terms-and-conditions/terms-and-conditions.module'
                    ).then((m) => m.TermsAndConditionsModule),
            },
            {
                path: 'error',
                canActivate: [AuthGuard],
                loadChildren: () =>
                    import('./modules/error/error.module').then(
                        (m) => m.ErrorModule
                    ),
            },
        ],
    },
    { path: '**', redirectTo: 'error/404', pathMatch: 'full' },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            paramsInheritanceStrategy: 'emptyOnly',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
